import Routers from "./routers/Routers";
import GlobalStyle from "./styles/GlobalStyle";

const App = (props) => {
  return (
    <>
      <GlobalStyle />
      <Routers />
    </>
  );
};

export default App;
